import { Modal, Form, Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import { exportNotesByYearAndClasses } from "../../api/notes";
import { useAcademicYear } from "../../core/common/context/AcademicYearContext";
import { toast } from "sonner";
import withPermission from "../../core/common/autorisations/withPermission";
import {
  Action,
  buildPermission,
  Resource,
} from "../../core/common/autorisations/permissionsMap";

type Props = {
  show: boolean;
  metaData: any;
  onClose: () => void;
};

const ExportNoteModal = ({ show, metaData, onClose }: Props) => {
  const { selectedYear } = useAcademicYear();
  const [selectedClasses, setSelectedClasses] = useState<string[]>([]);

  const handleSelect = (id: string) => {
    setSelectedClasses((prev) =>
      prev.includes(id) ? prev.filter((c) => c !== id) : [...prev, id],
    );
  };

  const handleExport = () => {
    try {
      if (selectedClasses.length === 0) {
        toast.error("Veuillez sélectionner au moins une classe.");
        return;
      }
      toast.promise(
        exportNotesByYearAndClasses({
          id_academicYear: selectedYear?.id,
          classes: selectedClasses,
        }),
        {
          loading: "Export en cours...",
          success: (data) => {
            // console.log("data export: ",data)
            const blob = new Blob([data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = URL.createObjectURL(blob);

            // Créer un lien temporaire
            const a = document.createElement("a");
            a.href = url;

            a.download = `noteExport.xlsx`;
            a.click();
            onClose();
            return "Export réussi !";
          },
          error: (error: any) => {
            // console.error("Error:export note Excel ", error);
            return (
              error.message ||
              error.response?.data?.message ||
              error.response?.data?.error ||
              "Une erreur s'est produite, Réessayez plus tard"
            );
          },
        },
      );
    } catch (error: any) {
      // console.error(error);
    }
  };

  useEffect(() => {
    if (!show) {
      setSelectedClasses([]);
    }
  }, [show]);

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Exporter les notes</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="text-muted mb-3">
          Sélectionnez une ou plusieurs classes pour exporter leurs notes.
        </p>

        <Row xs={1} md={2} className="g-2 d-flex align-items-stretch ">
          {metaData && metaData?.classes.length > 0 ? (
            metaData?.classes.map((classe: any) => {
              const isSelected = selectedClasses.includes(classe.id);
              return (
                <Col key={classe.id} className="h-100">
                  <Form.Check
                    type="checkbox"
                    id={`class-${classe.id}`}
                    checked={isSelected}
                    onChange={() => handleSelect(classe.id)}
                    label={
                      <div
                        className={` d-flex justify-content-center align-items-center text-center fw-semibold rounded h-100 p-1 w-100 ${
                          isSelected
                            ? "bg-info bg-opacity-55 text-white"
                            : "bg-light text-dark"
                        }`}
                        style={{ cursor: "pointer" }}
                      >
                        <span className="w-100">
                          {classe.Level?.abbreviation} - {classe.label}
                        </span>
                      </div>
                    }
                    className="m-0 h-100 w-100"
                  />
                </Col>
              );
            })
          ) : (
            <p className="text-secondary">Aucune classe disponible.</p>
          )}
        </Row>
      </Modal.Body>

      <Modal.Footer className="gap-2">
        <button
          onClick={handleExport}
          className="btn btn-primary"
          disabled={selectedClasses.length === 0}
        >
          Exporter
        </button>
        <button onClick={onClose} className="btn btn-secondary">
          Fermer
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default withPermission(
  ExportNoteModal,
  [buildPermission(Resource.NOTE, Action.READ)],
  "masquer",
);
